// libs
import get from 'lodash/get';
import escapeRegExp from 'lodash/escapeRegExp';

// constants
import {
  ALL_BRANDS,
  ALL_BRANDS_CHANNEL_ID,
  BRANDS_CATEGORY_NAME,
  MASTER_DATA_ID,
} from './constants';

// defs
import { IBrandItem } from 'shared/api/mega-menu-v2/types';

// api
import { getMegaMenuV2 } from 'shared/api/mega-menu-v2';

// helpers
import { generateTrackingUrlForMegaMenu } from 'shared/components/Header/helpers';

export interface IBucketizedBrands {
  [item: string]: IBrandItem[];
}

export const getAllBrands = (data: any) => {
  const brandIds = [];
  return get(data, 'children_data', []).reduce((acc, subCategory) => {
    const brands = subCategory.children_data
      .filter((child) => brandIds.indexOf(child.id) === -1)
      .map((child) => {
        if (!brandIds.includes(child.id)) {
          brandIds.push(child.id);
          return child;
        }
      })
      .filter(Boolean);
    return [...acc, ...brands];
  }, []);
};

const transformData = (data: object) => {
  // Find master category, then find Brands category
  const brandsData = data.response.children_data
    .filter((item) => {
      return item.id === MASTER_DATA_ID;
    })[0]
    .children_data.filter((item) => {
      return item.name === BRANDS_CATEGORY_NAME;
    });

  // Createing a new category with all brands merged
  const allBrands = {
    children_data: [],
    name: ALL_BRANDS,
    image: '',
  };
  allBrands.children_data = getAllBrands(brandsData[0]);
  brandsData[0].children_data.push(allBrands);

  return brandsData[0];
};

export const DEFAULT_INITIALS = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const getBucketizedBrands = (brandsData: IBrandItem[]): IBucketizedBrands => {
  return brandsData.reduce((bucket: IBucketizedBrands, brand) => {
    let char: string = brand.name ? brand.name.substring(0, 1).toUpperCase() : DEFAULT_INITIALS[0];

    if (!DEFAULT_INITIALS.includes(char)) {
      char = DEFAULT_INITIALS[0];
    }

    if (bucket[char] === undefined) {
      bucket[char] = [];
    }

    bucket[char].push(brand);
    return bucket;
  }, {});
};

export const getMenuContent = async (storeId: string): Promise<any> => {
  const data = await getMegaMenuV2(storeId);
  return transformData(data);
};

export const getFilteredBrands = (brands: IBrandItem[], filterText: string) => {
  if (filterText.trim().length === 0) {
    return brands;
  }

  const filterRegExp = new RegExp(`${escapeRegExp(filterText)}`, 'i');

  return brands.filter((brand: { name: string }) => filterRegExp.test(brand.name));
};

export const customSort = (alphabet: string) => {
  return function (a, b) {
    const index_a = alphabet.indexOf(a[0]),
      index_b = alphabet.indexOf(b[0]);

    if (index_a === index_b) {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      }
      return 0;
    } else {
      return index_a - index_b;
    }
  };
};

export const sorter = customSort('abcdefghijklmnopqrstuvwxyz#');

export const generateTrackingURL = (brand: IBrandItem) => {
  const channel = `${ALL_BRANDS_CHANNEL_ID},${brand.name}`;

  return generateTrackingUrlForMegaMenu({ ...brand, channel, url: brand.action_url });
};
